<template lang="html">
  <v-app>
    <section v-if="isLapTopCheck">
      <v-content>
        <section>
          <v-container fluid>
            <v-layout align-center justify-center>
              <v-flex xs12 sm8 md4>
                <v-card class="elevation-10" width='auto'>
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>อัพเดทรูปพื้นหลัง</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-progress-linear :indeterminate="true" :active="show" v-if="this.show"></v-progress-linear>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      transition="scale-transition"
                    >
                      {{this.alertValue}}
                    </v-alert>
                    <v-form ref="form">
                      <v-flex xs12>
                        <v-select
                          v-model="image_index"
                          :items="items"
                          label="อันดับรูป"
                          outline>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        อัพโหลดรูป:
                        <input type="file" ref="image" accept="image/*" @change="onFilePicked">
                      </v-flex>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-on:click="addImage" round color="primary" dark>อัพเดทรูป</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <section>
          <!-- progress bar -->
          <v-container grid-list-md text-xs-center v-if="allUrl.length == 0 || allUrl === undefined">
            <div class="text-xs-center">
              <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <template>
                <v-alert :value="true" color="error" icon="warning">
                  Sorry, nothing to display here :(
                </v-alert>
              </template>
            </div>
          </v-container>
          <!-- end progress bar -->
          <v-container grid-list-xl text-xs-center v-else>
            <v-layout row wrap>
              <v-flex xs6 v-for="(value, index) in allUrl" :key="value.id" v-if="allUrl">
                <v-card class="elevation-7">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>รูปที่ {{ index +1 }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-img
                    :src="value.url"
                    :lazy-src="value.url"
                    aspect-ratio="1"
                    max-height="300"
                    contain
                    class="white"
                  >
                    <v-layout
                      slot="placeholder"
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                    </v-layout>
                  </v-img>
                  <v-card-title primary-title>
                  <div>
                    <h3 class="font-weight-medium" style="font-size:20px">ชื่อภาพ: {{ value.name }}</h3>
                  </div>
                </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <section>
          <div>
            <v-toolbar dark color="primary">
              <v-toolbar-title class="text-xs-center">ตัวอย่างภาพเคลื่อนไหว</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </div>
          <v-carousel height="auto">
            <v-carousel-item
              v-for="(item,i) in allUrl"
              :key="i"
              :src="item.url"
              >
            </v-carousel-item>
          </v-carousel>
        </section>
      </v-content>
    </section>

    <section v-else>
      <v-content>
        <section>
          <v-container fluid>
            <v-layout align-center justify-center>
              <v-flex xs12 sm8 md4>
                <v-card class="elevation-10" width='auto'>
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>อัพเดทรูปพื้นหลัง</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-progress-linear :indeterminate="true" :active="show" v-if="this.show"></v-progress-linear>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      transition="scale-transition"
                    >
                      {{this.alertValue}}
                    </v-alert>
                    <v-form ref="form">
                      <v-flex xs12>
                        <v-select
                          v-model="image_index"
                          :items="items"
                          label="อันดับรูป"
                          outline>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        อัพโหลดรูป:
                        <input type="file" ref="image" accept="image/*" @change="onFilePicked">
                      </v-flex>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-on:click="addImage" round color="primary" dark>อัพเดทรูป</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <section>
          <!-- progress bar -->
          <v-container grid-list-md text-xs-center v-if="allUrl.length == 0 || allUrl === undefined">
            <div class="text-xs-center">
              <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <template>
                <v-alert :value="true" color="error" icon="warning">
                  Sorry, nothing to display here :(
                </v-alert>
              </template>
            </div>
          </v-container>
          <!-- end progress bar -->
          <v-container grid-list-xl text-xs-center v-else>
            <v-layout column wrap>
              <v-flex xs12 v-for="(value, index) in allUrl" :key="value.id" v-if="allUrl">
                <v-card>
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>Item {{ index +1 }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-img
                    :src="value.url"
                    :lazy-src="value.url"
                    aspect-ratio="1"
                    max-height="100"
                    contain
                    class="white"
                  >
                    <v-layout
                      slot="placeholder"
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                    </v-layout>
                  </v-img>
                  <v-card-title primary-title>
                  <div>
                    <h3 class="font-weight-medium" style="font-size:20px">ชื่อภาพ: {{ value.name }}</h3>
                  </div>
                </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <section>
          <div>
            <v-toolbar dark color="primary">
              <v-toolbar-title class="text-xs-center">ตัวอย่างภาพเคลื่อนไหว</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </div>
          <v-carousel height="150">
            <v-carousel-item
              v-for="(item,i) in allUrl"
              :key="i"
              :src="item.url"
              contain>
            </v-carousel-item>
          </v-carousel>
        </section>
        <v-spacer></v-spacer>
      </v-content>
    </section>
  </v-app>
</template>

<script>
import firebase from 'firebase'
export default {
  props: ['callIntroImage', 'callDataProps', 'allUrl', 'isLapTopCheck'],
  data () {
    return {
      items: ['Picture1', 'Picture2', 'Picture3', 'Picture4'],
      image_index: '',
      alert: false,
      alertValue: '',
      alertType: 'warning',
      show: false
    }
  },
  created () {
    this.callIntroImage()
  },
  methods: {
    addImage () {
      let imageName = this.imageName
      let imageFile = this.imageFile
      let imageIndex = this.image_index
      var index = 0
      if (imageIndex && imageFile) {
        this.show = true
        if (imageIndex === 'Picture1') index = 0
        else if (imageIndex === 'Picture2') index = 1
        else if (imageIndex === 'Picture3') index = 2
        else if (imageIndex === 'Picture4') index = 3
        else { alert('Error') }
        // get the image linke in order to link to the img in storage
        var ref = firebase.database().ref('intro_images/' + index)
        var imageNewLink = ''
        ref.once('value').then((x) => {
          var imageLink = x.val().url
          // delete image in stroage
          firebase.storage().refFromURL(imageLink).delete().then((result) => {
            var checkPicture = firebase.storage().ref('intro_images/' + index + '_' + imageName)
            // add image in storage
            checkPicture.put(imageFile).then((picLink) => {
              // get picLink
              picLink.ref.getDownloadURL().then(link => {
                imageNewLink = link
              }).then((result) => {
                // add picklink to the correct index
                ref.set({ url: imageNewLink })
              }).then((result) => {
                // location.reload()
                // this.cancelAddProduct()
                this.show = false
                var alertStatue = true
                var alertValue = 'Upload Image Successful'
                var alertType = 'success'
                this.setAlert(alertStatue, alertValue, alertType)
              })
            })
          })
        }).catch((err) => {
          alert('error: ', err.message)
        })
      } else {
        var alertStatue = true
        var alertValue = 'Please choose image and image item!'
        var alertType = 'warning'
        this.setAlert(alertStatue, alertValue, alertType)
      }
    },
    cancelAddProduct () {
      this.alert = false
      this.$refs.form.reset()
    },
    setAlert (alert, alertVal, alertT) {
      this.alert = alert
      this.alertValue = alertVal
      this.alertType = alertT
      this.callIntroImage()
      this.callDataProps()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/listProductIntroPage.vue